<template>
    <div class="home">
        <Homehead :logo="logo"></Homehead>
        <Iconarea></Iconarea>
        <Swipe :swipedata="swipedata"></Swipe>
        <Prohot :prolist="prolist"></Prohot>
        <Safe :operation="operation"></Safe>
        <Bottom_comp></Bottom_comp>
        <Footer></Footer>
    </div>

</template>

<script>
    // @ is an alias to /src
    import Homehead from '@/components/home/Homehead.vue'
    import Iconarea from '@/components/home/Iconarea.vue'
    import Prohot from '@/components/home/Prohot.vue'
    import Safe from '@/components/home/Safe.vue'
    import Footer from '@/components/Footer.vue'
    import Swipe from '@/components/Swipe.vue'
    import Bottom_comp from '@/components/Bottom_comp.vue'


    export default {
        name: 'Index',
        data() {
            return {
                active: 0,
                logo :'',
                swipedata :Array(),
                prolist:[],
                operation:{},
                url:''
            };
        },
        mounted(){
           this.getIndex();
        },
        components: {
            Homehead,
            Iconarea,
            Footer,
            Swipe,
            Prohot,
            Safe,
            Bottom_comp
        },
        methods:{
            getIndex(){
                this.getReq('/getIndex').then((res)=>{
                    if(res.code==200){
                        let data  = res.data;
                        this.logo = data.logo;
                        this.swipedata = data.swipe;
                        this.prolist = data.prolist;
                        this.operation = data.operation;
                        this.$store.commit('setSiteinfo',data.siteinfo);

                    }
                })
            }
        }
    }
</script>
<style scoped>
    .home{
        background: #eeeeee;
    }
</style>
